import { type ReactNode } from 'react'
import { COMPANY_ICON_ID, type PinDisplayProps } from '@terros/common'
import { type CommonIconDisplayProps } from './types'
import { ProspectStageIcon } from './ProspectStageIcon'
import { IconEmojiDisplay } from './IconEmojiDisplay'
import { IconDisplay } from './IconDisplay'

type WorkflowIconDisplayProps = PinDisplayProps & CommonIconDisplayProps

export const WorkflowIconDisplay = ({ size = 'sm', ...props }: WorkflowIconDisplayProps): ReactNode => {
  if (props.type === 'tag') return
  if (props.type === 'initial') return <ProspectStageIcon size={size} />
  if (props.type === 'logo') return <IconDisplay color={props.color} icon={COMPANY_ICON_ID} size={size} />
  return <IconEmojiDisplay {...props} size={size} />
}
